module.exports = __webpack_public_path__ + "static/media/KS.e8f980f6.svg";